/**
 * How many course materials a calendar card announces: the count when there are any, null when
 * there are none or the backend predates TR-3 and sends no count, so the card shows no line.
 */
export function trainingMaterialCount(session: { materialCount?: number | null }): number | null {
  const count = session.materialCount;
  return typeof count === 'number' && count > 0 ? count : null;
}
